import { Icon } from "@/components";
import { cn } from "@/utils";
import { VariantProps, cva } from "class-variance-authority";
import { PropsWithChildren } from "react";

const variants = cva(
  "text-negative bg-negative-faint text-sm flex items-center gap-1.5",
  {
    variants: {
      variant: {
        banner: "justify-center px-5 py-1",
        rounded: "rounded-full px-3 py-1.5 w-fit font-bold text-sm",
      },
      color: {
        negative: "text-negative bg-negative/10",
        warning: "text-primary bg-primary/10",
      },
    },
    defaultVariants: {
      variant: "banner",
    },
  },
);

interface ErrorMessageProps extends VariantProps<typeof variants> {
  className?: string;
}

export function ErrorMessage({
  children,
  className,
  ...props
}: PropsWithChildren<ErrorMessageProps>) {
  return (
    <div className={cn(variants(props), className)}>
      <p>{children}</p>
      <Icon name="info" className="w-4 min-w-4" />
    </div>
  );
}
